import React from 'react';

import * as styles from './pagination.module.scss';
import ButtonLink from '../ui/buttonLink/buttonLink';
import classnames from 'classnames';

const Pagination = ({
  previous,
  next,
  className,
}: {
  previous: {
    title: string;
    path?: string;
    isDisabled: boolean;
  };
  next: {
    title: string;
    path?: string;
    isDisabled: boolean;
  };
  className?: string;
}) => {
  return (
    <div className={classnames(styles.root, className)}>
      {!previous.isDisabled ? (
        <ButtonLink className={styles.prev} href={previous.path}>
          {previous.title}
        </ButtonLink>
      ) : (
        <ButtonLink className={styles.prev}>{previous.title}</ButtonLink>
      )}
      {!next.isDisabled ? (
        <ButtonLink className={styles.next} href={next.path}>
          {next.title}
        </ButtonLink>
      ) : (
        <ButtonLink className={styles.next}>{next.title}</ButtonLink>
      )}
    </div>
  );
};

export default Pagination;
